import { useState } from 'react';

import { showAlert } from 'components/shared/Alert/Alert';

const useCopy = ({ isText = true, alert = true } = {}) => {
  const [copyText, setCopyText] = useState(isText ? 'Copy' : '');

  const copyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopyText('Copied');
        setTimeout(() => setCopyText(isText ? 'Copy' : ''), 2000);
        if (alert) {
          showAlert({
            title: 'Copied to clipboard',
            color: 'success',
            duration: 500
          });
        }
      })
      .catch(() => {
        setCopyText("Couldn't copy");
        if (alert) {
          showAlert({
            title: "Couldn't copy",
            color: 'danger',
            duration: 500
          });
        }
      });
  };

  return { copyText, copyToClipboard };
};

export default useCopy;
